import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { getObjectByCache, getSpecificBasicData, resolveSpecificField2ItemByCustomType, cacheKeys } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import * as StuffyType from '@/class/cargo/model/parameters/StuffyType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { Company } from '@/class/model/mdm/Company'
import { Contract } from '@/class/model/mdm/Contract'
import { Voyage } from '@/class/model/mdm/Voyage'
import { Customer } from '@/class/model/mdm/Customer'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { Trucking } from '@/class/model/booking/Trucking'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import {
  getSites,
  addSites,
  queryCompanyUserByCompany,
  checkCompany,
  queryCompanyCmpIdxByCompanyUser,
  queryUserRoleByCompany,
  validateReleaseNumberCustomer
} from '@/api/company'
import { checkPoNoIsExist, getCustomerByRole } from '@/api/booking/job'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { getPortCodeByMapping } from '@/api/seaport'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { getPartnerByPoNo } from '@/api/projectManage/project'
import ColumnUtils from '@/utils/ColumnUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache } from '@/utils/cacheManager'
import $store from '@/store'

export default {
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      /* ****************************** 初始化 begin ****************************** */
      this.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode'))
      this.isHc = String(cache.config.get('ToExoSystem')) === 'HC'
      this.salesOfficeCheck = Number(this.context.config.get('SalesOfficeCheck')) === 1
      this.editVesselVoyageMode = Number(this.context.config.get('EditVesselVoyageMode'))
      this.validateCustomerSales = Number(this.context.config.get('BookingValidateCustomerSales')) === 1
      this.isSpecifiedSalesBusiness = Number(this.context.config.get('IsSpecifiedSalesBusiness')) === 1
      this.salesCanSeeBookingAgent = Number(this.context.config.get('SalesCanSeeBookingAgent')) === 1
      this.openProjectConfig = Number(this.context.config.get('openProjectConfig')) === 1
      this.isAddUserDefinedRoles = Number(this.context.config.get('IsAddUserDefinedRoles')) === 1
      this.sEUseDischargingPort5Code = Number(this.context.config.get('SEUseDischargingPort5Code')) === 1
      this.needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      this.isProjectLinkedCustomer = Number(this.context.config.get('isProjectLinkedCustomer')) === 1 // 项目是否和委托单位关联
      this.hasChooseOwnTransceiverPermission = this.$checkPermission(['role_RemoteBooking_ChooseOwnTransceiver']) && !this.$store.getters.isAdmin
      this.creditOpen = Number(this.context.config.get('creditOpen'))
      this.isShowContactPersonDetail = String(this.context.config.get('ToExoSystem')) === 'HC'
      this.customerCmpList = null
      this.contactList = []
      this.csrList = null
      this.cargoSalesList = null
      this.salesList = null
      this.txtSalesOffice = ''
      this.dcList = null
      this.voyages = []
      this.doorList = []
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      /* ****************************** end ****************************** */
      this.job = row
      if (!row.uuid && row.customerId > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === row.customerId)
        if (cmp) {
          await this.loadCustomerDetail(cmp)
        }
      }
      // 验证销售
      await this.loadCustomerSales()
      const job = this.job
      const office = this.context.officeList.find(p => p.officeId === job.salesOffice)
      this.txtSalesOffice = office ? office.chineseName : ''
      if (!job.uuid) {
        await this.containerLoadType_Change(true)
      }
      await this.loadTrucking()
      this.changeLockSales()
      await this.loadSalesPrivateCustomer()
      this.loadPrivateCompanyList()
      await this.loadCargoDocHander()
      if (job.op > 0) {
        const usr = this.context.userList.find(p => p.userId === job.op)
        if (usr) {
          usr.value = job.op
          if (this.action !== 'copy') {
            this.txtOPChangeHandler(usr)
          }
        }
      }
      // 航线负责人 office/部门 兜底：复制/带入时 plannerOffice 可能为 0，按 planner 反查回填，避免航线部门下拉空
      if (job.planner > 0 && !job.plannerOffice) {
        await this.fillPlannerOfficeDept(job.planner)
      }
      if (!job.uuid && job.customerId > 0) {
        const company = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        await this.txtCustomerId_changeHandler(company || {})
      }
      // 这段赋值 需要放到 txtCustomerId_changeHandler 之后，因为第一次进来时 前面这个方法里会调用 loadSites，这个方法会清空详细地址
      if (this.action === 'add' && job.inquiryPrice && job.inquiryPrice.prePortEnable) {
        this.truckingInfo.province = job.inquiryPrice.province
        this.truckingInfo.cityNew = job.inquiryPrice.city
        this.truckingInfo.county = job.inquiryPrice.districts
        this.truckingInfo.town = job.inquiryPrice.townUuid
        this.truckingInfo.doorAddr = job.inquiryPrice.detailAddress
        console.log('job.inquiryPrice.detailAddress：', job.inquiryPrice.detailAddress)
        if (job.selectedPrePortData && job.selectedPrePortData.supplier) {
          // 询价单 门点信息 带到 业务中
          const supplierCompany = await Company.getCompanyById(job.selectedPrePortData.supplier)
          // 供应商 选中的是【卡车公司】时，才带门点信息
          if (supplierCompany && supplierCompany.truckCmp) {
            this.truckingInfo.carryingCmp = job.selectedPrePortData.supplier
            job.carryingCmp = this.truckingInfo.carryingCmp
            const contacts = await new Company(supplierCompany).getContacts()
            if (contacts && contacts.length > 0) {
              const contact = contacts.find(p => !!p.defaultContact) || contacts[0]
              this.truckingInfo.driver = contact.contactPerson
              this.truckingInfo.driverTel = contact.telephone
            }
            const driverInfomations = await Company.loadDriverInformation(supplierCompany.uuid)
            if (driverInfomations && driverInfomations.length > 0) {
              const driver = driverInfomations.find(p => !!p.defaultDriver) || driverInfomations[0]
              this.truckingInfo.plateNumber = driver.plateNumber
              this.truckingInfo.driverPhone = driver.driverPhone
              this.truckingInfo.driverIdCard = driver.driverIdCard
            }
          }
        }
      }
      this.showBargeCustomCutoff = Boolean(job.bargeCustomCutoff) || job.showBargeCustomCutoff === true
      if (job.uuid && this.isEdit) {
        const job = new SeaExportJob(this.job)
        await Promise.all([
          job.getContainerUsages(),
          job.getContainers()
        ])
      }
      if (this.action !== 'copy') {
        OverseaCustomerUtils.loadOverseaAgentChanged(this)
      }
      // CARGO-33935 新增的时候，默认把卸货港代码同步到订舱页面
      if (this.action === 'add') {
        this.refreshPortCode()
      }
      if (!this.isEdit && job.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        this.poNoRed = await checkPoNoIsExist(job.poNo, job.uuid).then(res => res.data) > 0
      }
      if (!job.uuid) {
        JobUtils.matchUserPortConfig(this, job, true)
        JobUtils.matchRegionWarehouseMappingConfig(job, null, true, null, null, true)
      } else {
        JobUtils.matchUserPortConfig(this, job, true, null, { keepOriginValue: true })
      }
      if (job.uuid) {
        JobUtils.loadCompanyCargoSales(this, job, this.isSpecifiedSalesBusiness)
      }
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setOperationDateData()
        this.setUserDefinedRoleData()
      }
    },
    async loadCustomerDetail(company) {
      if (this.isEdit) {
        const customerDetail = await new Company(company).getCustomerDetail()
        if (customerDetail && customerDetail.designated) {
          // 指定货
          this.job.cargoSource = CargoSource.NC_CARGO_SOURCE.code
        } else {
          // 自揽货
          this.job.cargoSource = CargoSource.SC_CARGO_SOURCE.code
        }
        await this.txtCargoSourceChangeHandler()
      }
      this.contactList = await new Company(company).getContacts()
      if (this.isEdit) {
        this.onCustomerContactLoad()
      }
    },
    onCustomerContactLoad() {
      if (this.contactList && this.contactList.length > 0) {
        const contact = this.getDefaultContact(this.contactList)
        if (contact) {
          this.job.customerContact = contact.contactPerson
          this.job.contactTelephone = contact.telephone
          this.job.contactFax = contact.fax
        }
      }
    },
    /**
     * 获取默认联系人
     */
    getDefaultContact(ary) {
      let rs = null
      if (ary && ary.length > 0) {
        rs = ary[0]
        for (const contact of ary) {
          if (contact.defaultContact) {
            rs = contact
            break
          }
        }
      }
      return rs
    },
    /**
     * 1、是否启用报价委托订舱根据销售验证客户
     * 2、是否启用合作伙伴对应的服务人员设置
     * 全部满足才能编辑销售
     */
    async loadCustomerSales() {
      if (this.isSpecifiedSalesBusiness && this.job.customerId > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
        if (cmp) {
          const companyUsers = await Company.getCompanyUsers(cmp.uuid)
          await this.loadCustomerSalesHandler(companyUsers)
        }
      }
    },
    async loadCustomerSalesHandler(companyUsers) {
      const job = this.job
      // 销售
      let salesList = []
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
            const user = this.context.userList.find(p => p.userId === u.userId)
            if (user) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                        salesList = [user, ...salesList]
                      } else {
                        salesList.push(user)
                      }
                    }
                  }
                } else {
                  if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                    salesList = [user, ...salesList]
                  } else {
                    salesList.push(user)
                  }
                }
              }
            }
          }
        }
      }
      this.salesList = salesList
    },
    async loadTrucking() {
      const job = this.job
      if (!job.trucking || job.trucking.length === 0) {
        job.trucking = []
        const truckingInfo = new Trucking().fillDefaultValue().getData()
        truckingInfo.loadingPortService = true
        truckingInfo.jobUuid = job.uuid
        truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(job)
        job.trucking.push(truckingInfo)
      }
      this.truckingInfo = job.trucking[0]
      this.addTruckingToModifiedSet(this.truckingInfo)
      await this.loadSites()
      job.carryingCmp = this.truckingInfo.carryingCmp
    },
    changeLockSales() {
      const user = this.context.user
      if (this.validateCustomerSales && user.userId !== 250000 && !user.admin) {
        if (!this.job.uuid) {
          this.job.sales = user.userId
          this.txtSales_changeHandler({ ...user, value: user.userId })
        }
      }
    },
    // 外部销售只能加载自己的客户
    async loadSalesPrivateCustomer() {
      this.customerCmpList = null
      if (this.isSpecifiedSalesBusiness && this.$checkPermission(['role_RemoteBooking_queryPrivateCustom']) && !this.context.user.admin) {
        await queryCompanyUserByCompany({ userId: this.context.user.userId, roleType: 2, lob: 'SE' }).then(res => {
          this.customerCmpList = this.context.companyList.filter(p => res.data.includes(p.uuid))
        })
        // if (this.isHc) {
        //   // 查看 当前登录用户所关联的合作伙伴（与上面集合 取并集）
        //   this.customerCmpList = await Company.unionAllUserRoleCompany(this.$store.getters.currentOfficeId,
        //       this.$store.getters.userId, 'SE', this.customerCmpList, this.context.companyList)
        // }
      } else if (!this.context.user.admin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
        await getCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
          this.customerCmpList = this.context.companyList.filter(p => res.data.includes(p.cmpIdx))
        })
        // if (this.isHc) {
        //   // 查看 当前登录用户所关联的合作伙伴（与上面集合 取并集）
        //   this.customerCmpList = await Company.unionAllUserRoleCompany(this.$store.getters.currentOfficeId,
        //       this.$store.getters.userId, 'SE', this.customerCmpList, this.context.companyList)
        // }
      }
    },
    // 加载服务人员关联的客户或创建人是自己的合作伙伴
    loadPrivateCompanyList() {
      this.privateShipperList = []
      this.privateConsigneeList = []
      this.privateNotifyList = []
      if (this.isSpecifiedSalesBusiness && this.hasChooseOwnTransceiverPermission) {
        queryCompanyCmpIdxByCompanyUser({ userId: this.context.user.userId, lob: 'SE' }).then(res => {
          this.privateShipperList = this.context.companyList.filter(p => (res.data.includes(p.uuid) || p.createdBy === this.context.user.userId) &&
              p.active && p.seaExport && p.shipper && (p.branchId === this.$store.getters.currentOfficeId || p.branchId === 1))
          this.privateConsigneeList = this.context.companyList.filter(p => (res.data.includes(p.uuid) || p.createdBy === this.context.user.userId) &&
              p.active && p.seaExport && p.consignee && (p.branchId === this.$store.getters.currentOfficeId || p.branchId === 1))
          this.privateNotifyList = this.context.companyList.filter(p => (res.data.includes(p.uuid) || p.createdBy === this.context.user.userId) &&
              p.active && p.seaExport && p.notify && (p.branchId === this.$store.getters.currentOfficeId || p.branchId === 1))
        })
      }
    },
    async loadCargoDocHander() {
      const job = new SeaExportJob(this.job)
      this.mblDoc = await job.getMainMbl()
      if (!this.mblDoc) {
        this.mblDoc = new SeaCargoDoc().fillDefaultValue().getData()
        this.initCargoDoc(this.mblDoc, this.job, 'MBL')
      }
      if (!this.mblDoc.cargoManifestName) {
        this.mblDoc.cargoManifestName = job.cargoEnglishName
      }
      this.hdoc = await job.getMainHbl()
      if (!this.hdoc) {
        this.hdoc = new SeaCargoDoc().fillDefaultValue().getData()
        this.initCargoDoc(this.hdoc, this.job, 'HBL')
      }
      if (!this.hdoc.cargoManifestName) {
        this.hdoc.cargoManifestName = job.cargoEnglishName
      }
    },
    initCargoDoc(doc, row, docType) {
      new SeaCargoDoc(doc).reset()
      doc.docType = docType
      doc.mark = row.mark
      doc.cargoEnglishName = row.cargoEnglishName
      doc.notifyLine1 = 'SAME AS CONSIGNEE'
      // 提单发货地，应该是seaopinput.placeOfReceipt
      doc.dispatchingPlace = row.dispatchingPlace
      doc.dispatchingPlaceCode = row.dispatchingPlaceCode
      // 提单起运港
      if (row.loadingPortCode) {
        console.log('posr', this)
        const ports = this.context.seaPortList.filter(p => p.code === row.loadingPortCode)
        if (ports && ports.length > 0) {
          doc.loadingPort = ports[0].englishName
        }
        doc.loadingPortCode = row.loadingPortCode
      }
      // 提单卸货港
      if (row.dischargingPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.dischargingPortCode)
        if (ports && ports.length > 0) {
          doc.dischargingPort = ports[0].englishName
        }
        doc.dischargingPortCode = row.dischargingPortCode
      }
      // 提单目的港
      if (row.destinationPortCode) {
        const ports = this.context.seaPortList.filter(p => p.code === row.destinationPortCode)
        if (ports && ports.length > 0) {
          doc.destinationPort = ports[0].englishName
        }
        doc.destinationPortCode = row.destinationPortCode
      }
      if (doc.docType !== 'MBL' && doc.docType !== 'MBL2') {
        // 提单收货地
        doc.destinationPlace = row.destinationPlace
      }
      if (doc.docType === 'MBL' && row.masterFlag) {
        doc.shipperLine1 = this.context.office.seaAddressLine1
        doc.shipperLine2 = this.context.office.seaAddressLine2
        doc.shipperLine3 = this.context.office.seaAddressLine3
        doc.shipperLine4 = this.context.office.seaAddressLine4
        doc.shipperLine5 = this.context.office.seaAddressLine5
        doc.shipperLine6 = this.context.office.seaAddressLine6
      }
      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(row, doc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = Number(this.context.config.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        doc.insidePacking = row.insidePacking
      }
      // doc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(doc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      if (!doc.releaseType) {
        const releaseType = Number(this.context.config.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          doc.releaseType = 1
          doc.blNumber = 'THREE'
        } else if (releaseType === 2) {
          doc.releaseType = 3
          doc.blNumber = 'ONE'
        }
      } else { // 重置提单份数
        if (doc.releaseType === 1) {
          doc.BLNumber = 'THREE'
        } else {
          doc.BLNumber = 'ONE'
        }
      }
      doc.state = 1
      row.seaCargoDoc.push(doc)
    },
    /**
     * 修改货物信息
     */
    async cargoCodeChange(data) {
      const job = this.job
      job.cargoCode = data
      if (data === null || data === '') {
        job.cargoCode = data
        job.cargoName = ''
      } else {
        const cargoInformation = getObjectByCache(TYPE_NAMES.basic_data_CargoInformation, 'code', data)
        if (cargoInformation) {
          job.cargoCode = cargoInformation.code
          job.cargoName = cargoInformation.englishName
        }
      }
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaExport && item.active
    },
    // 门店地址
    async loadSites() {
      let cmp = null
      if (this.job.customerId > 0) {
        cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId)
      }
      this.doorList = []
      if (cmp) {
        await getSites(cmp.uuid).then(res => {
          const keySet = new Set()
          for (const item of res.data) {
            if (keySet.has(item.name)) {
              continue
            }
            this.doorList.push(item)
            keySet.add(item.name)
          }
        })
      }
      // 编辑业务时，如果门点是新增的，”门点“没有维护，清空门点相关信息
      if (!this.truckingInfo.uuid && this.isEdit) {
        const door = this.doorList.find(p => p.name === this.truckingInfo.doorName)
        if (!door) {
          this.truckingInfo.doorName = ''
          this.truckingInfo.doorMan = ''
          this.truckingInfo.doorManTel = ''
          this.truckingInfo.doorAddr = ''
        }
      }
    },
    mblOnlyChange(val) {
      this.job.signMBL = (this.job.mblOnly || this.job.signMBL)
      if (this.job.mblOnly) {
        this.job.signHBL = false
      }
    },
    destinationPortServiceChange() {
      if (!this.job.destinationPortService) {
        this.job.dischargingPortDoor = false
        this.job.usCustomsClearance = false
        this.job.destPortCustomsClearance = false
      }
    },
    loadingTerm_Change(fieldName) {
      const job = this.job
      if (fieldName === 'warehousing') {
        if (!job.warehousing) {
          job.warehouseCmp = 0
          if (job.warehouseInfo && job.warehouseInfo.length > 0) {
            for (const item of job.warehouseInfo) {
              if (item.uuid) {
                item.jobUuid = ''
                this.addWarehouseToModifiedSet(item)
              } else {
                this.removeWarehouseFromModifiedSet(item)
              }
            }
          }
        }
      } else if (fieldName === 'landTransportation') {
        if (!job.landTransportation) {
          job.carryingCmp = 0
          // 取消勾选客户门点/提货，清空客户门点页签信息
          if (job.trucking && job.trucking.length > 0) {
            for (const item of job.trucking) {
              if (item.uuid) {
                item.jobUuid = ''
                this.addTruckingToModifiedSet(item)
              } else {
                this.removeTruckingFromModifiedSet(item)
              }
            }
          }
          this.truckingInfo.doorName = ''
          this.truckingInfo.doorMan = ''
          this.truckingInfo.doorManTel = ''
          this.truckingInfo.doorAddr = ''
        } else {
          this.truckingInfo.jobUuid = this.job.uuid
        }
      }
    },
    // 添加warehouseInfo到被修改的集合中
    addWarehouseToModifiedSet(warehouse) {
      const modifiedData = this.context.modifiedData
      modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
      if (!modifiedData.warehouseInfo.includes(warehouse)) {
        modifiedData.warehouseInfo.push(warehouse)
      }
    },
    // 将warehouseInfo从被修改的集合中移除
    removeWarehouseFromModifiedSet(warehouse) {
      const modifiedData = this.context.modifiedData
      if (modifiedData.warehouseInfo && modifiedData.warehouseInfo.includes(warehouse)) {
        const index = modifiedData.warehouseInfo.indexOf(warehouse)
        if (index > -1) {
          modifiedData.warehouseInfo.splice(index, 1)
        }
      }
    },
    // 添加truckingInfo到被修改的集合中
    addTruckingToModifiedSet(truckingInfo) {
      const modifiedData = this.context.modifiedData
      modifiedData.truckingInfo = modifiedData.truckingInfo || []
      if (!modifiedData.truckingInfo.includes(truckingInfo)) {
        modifiedData.truckingInfo.push(truckingInfo)
      }
    },
    // 将truckingInfo从被修改的集合中移除
    removeTruckingFromModifiedSet(truckingInfo) {
      const modifiedData = this.context.modifiedData
      if (modifiedData.truckingInfo && modifiedData.truckingInfo.includes(truckingInfo)) {
        const index = modifiedData.truckingInfo.indexOf(truckingInfo)
        if (index > -1) {
          modifiedData.truckingInfo.splice(index, 1)
        }
      }
    },
    async txtCustomerId_changeHandler(company) {
      this.cargoSalesList = null
      if (company.cmpIdx > 0) {
        const validateRes = await validateReleaseNumberCustomer({
          companyId: company.cmpIdx,
          officeId: this.$store.getters.currentOfficeId
        })
        if (validateRes && validateRes.data && validateRes.data.allowed === false) {
          if (validateRes.data.message) {
            this.$message.warning(validateRes.data.message)
          }
          this.job.customerId = 0
          return
        }
        // 中邮委托单位是否黑名单
        const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
        if (blacklist) {
          // return
        }
        const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
        if (isForbid) {
          this.job.customerId = 0
          this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
          return
        }

        // 合同限制校验：检查是否启用合同限制且可放号天数<=0
        const contractLimitEnabled = company.contractLimitEnabled
        const availableDays = company.availableReleaseDays

        // contractLimitEnabled 可能是 '1' 或 1
        if (contractLimitEnabled === '1' || contractLimitEnabled === 1) {
          // availableReleaseDays 可能是数字或字符串，需要转换
          const daysNum = parseInt(availableDays) || 0
          if (daysNum <= 0) {
            const companyName = company.chineseName || company.englishName || '该委托单位'
            this.$message.warning(`${companyName} 未上传合同/合同失效，无法放号，请联系客户管理人员`)
            this.job.customerId = 0
            return
          }
        }

        const days = await JobUtils.checkEtdDaysCreditInfo(company.cmpIdx)
        if (days > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_EtdExceedsDays'))
          this.job.customerId = 0
          return
        }
        if (this.job.customerId && parseInt(this.job.customerId) > 0) {
          this.job.preCustomerId = this.job.customerId
        }
        this.context.reloadCharge = SEUtils.refreshChargeAccountId(this.job, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData) // 这里返回true，说明修改了费用结算对象以及开票抬头，需要将费用参与保存
        this.job.customerId = company.cmpIdx
        await this.loadCustomerDetail(company)
        if (company.incoTerm) {
          const incoTerm = company.incoTerm.split(',')
          if (incoTerm.length > 0) {
            this.job.incoTerm = incoTerm[0]
          }
        }
        if (this.creditOpen) {
          await this.checkNewJobCreditInfo()
        }
        if (this.context.user.admin || !this.validateCustomerSales) {
          await this.customerIdChangeHandler(company)
        } else {
          await checkCompany({ sales: this.context.user.userId, companyUuid: company.uuid }).then(async res => {
            if (res.data) {
              await this.customerIdChangeHandler(company)
            } else {
              this.$confirm(this.$t('CargoMsg.Cargo_TheClientDoesNotBelongToYourCustomerTips'), this.$t('common.tips.prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                const job = this.job
                job.customerId = 0
                job.contactTelephone = ''
                job.contactFax = ''
                job.customerContact = ''
                this.contactList = []
              }).catch()
            }
          })
        }
      } else {
        this.job.customerId = 0
        this.job.cargoSalesId = 0
        if (this.job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
          this.txtSalesOffice = ''
          this.job.sales = 0
          this.salesList = null
        }
      }
      JobUtils.loadCompanyCargoSales(this, this.job, this.isSpecifiedSalesBusiness, true)
    },
    async customerIdChangeHandler(company) {
      if (this.isSpecifiedSalesBusiness) {
        await this.loadCompanyUser(company)
      } else {
        this.changeCustomerId()
      }
    },
    /**
     * 按业务指定销售
     */
    async loadCompanyUser(company) {
      if (company) {
        await Company.getCompanyUsers(company.uuid).then(async data => {
          await this.loadCompanyUserHandler(data)
        })
      } else {
        this.salesList = null
      }
    },
    async loadCompanyUserHandler(companyUsers) {
      const job = this.job
      // 销售
      let salesList = []
      let salesDefaultId = 0
      // 客服
      const csrList = []
      let csrDefaultId = 0
      let matchCargoSourceCsrId = 0
      // 单证
      const dcList = []
      let dcDefaultId = 0
      let matchCargoSourceDcId = 0
      // 揽货销售
      const cargoSalesList = []
      let cargoSalesId = 0
      // 操作
      const opList = []
      let opDefaultId = 0
      // 海外客服
      const overseaOpList = []
      let overseaOpDefaultId = 0
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
            const user = this.context.userList.find(p => p.userId === u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (u.defaultUser) {
                        salesDefaultId = u.userId
                      }
                      if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                        salesList = [user, ...salesList]
                      } else {
                        salesList.push(user)
                      }
                    }
                  }
                } else {
                  if (u.defaultUser) {
                    salesDefaultId = u.userId
                  }
                  if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                    salesList = [user, ...salesList]
                  } else {
                    salesList.push(user)
                  }
                }
              } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
                if (u.defaultUser) {
                  csrDefaultId = u.userId
                }
                if (matchCargoSourceCsrId === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                  matchCargoSourceCsrId = u.userId
                }
                csrList.push(user)
              } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
                if (u.defaultUser) {
                  dcDefaultId = u.userId
                }
                if (matchCargoSourceDcId === 0 && job.cargoSource && u.cargoSource === job.cargoSource) {
                  matchCargoSourceDcId = u.userId
                }
                dcList.push(user)
              } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
                if (u.defaultUser) {
                  cargoSalesId = u.userId
                }
                cargoSalesList.push(user)
              } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
                if (u.defaultUser) {
                  opDefaultId = u.userId
                }
                opList.push(user)
              } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                if (u.defaultUser) {
                  overseaOpDefaultId = u.userId
                }
                overseaOpList.push(user)
              }
            }
          }
        }
      }
      if (this.isSpecifiedSalesBusiness) {
        this.salesList = salesList
        if (salesList.length > 0) {
          if (salesDefaultId > 0) {
            if (!this.validateCustomerSales) {
              job.sales = salesDefaultId
            } else {
              job.sales = salesList[0].userId
            }
          } else {
            job.sales = salesList[0].userId
          }
          this.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.sales)
            this.txtSales_changeHandler({ ...user, value: user.userId })
          })
        } else {
          // job.sales = 0
          // job.salesDepartment = 0
          // this.txtSalesOffice = ''
        }
        // 客服
        if (csrList.length > 0) {
          if (matchCargoSourceCsrId > 0) {
            job.csr = matchCargoSourceCsrId
          } else if (csrDefaultId > 0) {
            job.csr = csrDefaultId
          } else {
            job.csr = csrList[0].userId
          }
          console.log('job.csr===========', job.csr)
          this.view.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.csr)
            this.csrChangeHandler({ ...user, value: user.userId })
          })
        } else {
          // job.csr = 0
          // job.csrDepartment = 0
        }
        // 单证
        if (dcList.length > 0) {
          if (matchCargoSourceDcId > 0) {
            job.dc = matchCargoSourceDcId
          } else if (dcDefaultId > 0) {
            job.dc = dcDefaultId
          } else {
            job.dc = dcList[0].userId
          }
          this.view.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.dc)
            this.dcChangeHandler({ ...user, value: user.userId })
          })
        } else {
          // job.dc = 0
          // job.dcDepartment = 0
        }
        // 揽货销售
        if (cargoSalesList.length > 0) {
          if (cargoSalesId > 0) {
            job.cargoSalesId = cargoSalesId
          } else {
            job.cargoSalesId = cargoSalesList[0].userId
          }
          this.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.cargoSalesId)
            this.cargoSalesChargeHandler({ ...user, value: user.userId })
          })
        } else {
          // job.cargoSalesId = 0
          // job.cargoSalesOffice = 0
          // job.cargoSalesDepartment = 0
        }
        if (this.isHc) {
          // 操作
          if (opList.length > 0) {
            if (opDefaultId > 0) {
              job.op = opDefaultId
            } else {
              job.op = opList[0].userId
            }

            const user = await User.getUserById(job.op)
            this.$nextTick(() => {
              this.txtOPChangeHandler({ ...user, value: user.userId })
            })
          } else {
            // job.op = 0
            // job.opDepartment = 0
          }
          // 海外客服
          if (overseaOpList.length > 0) {
            if (overseaOpDefaultId > 0) {
              job.overseaOp = overseaOpDefaultId
            } else {
              job.overseaOp = overseaOpList[0].userId
            }

            const user = await User.getUserById(job.overseaOp)
            this.$nextTick(() => {
              OverseaCustomerUtils.overseaOpChangeHandler(this, { ...user, value: user.userId })
            })
          } else {
            // job.overseaOp = 0
            // job.overseaOpDepartment = 0
          }
        }
      }
      const chk = this.checkCustomerSales()
      if (!chk) {
        this.$message.warning('亲，只能选择销售所关联的客户(⊙o⊙)哦')
        this.job.customerId = 0
        return
      }
      await this.loadSites()
    },
    checkCustomerSales() {
      if (!this.validateCustomerSales || !this.salesList || this.salesList.length === 0 || this.job.sales <= 0) {
        return true
      }
      for (const u of this.salesList) {
        if (u.userId === this.job.sales) {
          return true
        }
      }
      return false
    },
    changeCustomerId() {
      this.getCustmerSales()
      this.loadSites()
    },
    tfLinkman_closeHandler() {
      const contact = this.contactList.find(p => p.contactPerson === this.job.customerContact)
      if (contact) {
        this.job.contactTelephone = contact.telephone
        this.job.contactFax = contact.fax
      }
    },
    // 客服改变
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    async txtSales_changeHandler(data) {
      const job = this.job
      job.sales = data.value
      job.salesOffice = 0
      this.txtSalesOffice = ''
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
          const office = await Office.getOfficeById(job.salesOffice)
          this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                this.loadCompanyOffice()
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
              this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
            }
          }
        }
      }
    },
    loadCompanyOffice() {
      const job = this.job
      const office = this.context.officeList.filter(p => p.officeId === job.salesOffice)[0]
      if (office) {
        this.txtSalesOffice = this.isZh ? office.chineseName : office.englishName
      } else {
        this.txtSalesOffice = ''
      }
    },
    /**
     * 非委托单(操作分公司可修改,客服跟销售分公司,根据操作分公司刷新操作、操作部门、单证)
     * 委托单(操作分公司不可修改,客服跟操作分公司,根据操作分公司刷新操作、操作部门、单证)
     * HQ单(操作分公司可修改,客服跟操作分公司,根据操作分公司刷新操作、客服、操作部门、单证)
     */
    isEntrustOrder() {
      const job = this.job
      let company = null
      if (job.customerId > 0) {
        company = this.context.companyList.find(p => p.cmpIdx === job.customerId)
      }
      if ((job.salesOffice === this.context.office.officeId && !job.trustFromJob && company && company.linkedBranchId === 0) || (job.salesOffice === 1)) {
        return false // 非委托单
      }
      return true
    },
    /**
     * 航线改变
     */
    async txtPlannerChangeHandler(data) {
      const job = this.job
      if (data.value) {
        const user = new User(data)
        job.planner = user.userId
        const offices = await User.getUserDepartmentOffices('role', 'seaLine', data.value)
        if (offices && offices.length > 1) {
          // 多公司仅当命中当前分公司才回填；否则不臆测，由用户手动选航线部门（保存时 Rule 1 校验必填）
          const item = offices.find(o => o.officeId === this.context.office.officeId)
          if (item) {
            const office = await Office.getOfficeById(item.officeId)
            job.plannerOffice = office ? office.officeId : 0
            job.plannerDepartment = item.departmentId
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'seaLine')
          job.planner = user.userId
          job.plannerDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.plannerOffice = office ? office.officeId : 0
        }
      } else {
        job.planner = 0
        job.plannerDepartment = 0
        job.plannerOffice = 0
      }
    },
    /**
     * 按 航线负责人 userId 回填 航线公司(plannerOffice)/航线部门(plannerDepartment)
     * 多公司优先当前分公司，否则取首个（用于复制/带入时 plannerOffice 缺失的兜底回填）
     */
    async fillPlannerOfficeDept(plannerUserId) {
      const job = this.job
      const offices = await User.getUserDepartmentOffices('role', 'seaLine', plannerUserId)
      if (!offices || offices.length === 0) return // 无 sealine 部门：交给 Rule 1 拦截
      // 多公司优先当前分公司；当前分公司不在其中则不臆测，留给用户手动选（保存时 Rule 1 校验）
      const item = offices.length > 1 ? offices.find(o => o.officeId === this.context.office.officeId) : offices[0]
      if (!item) return // 多公司且无当前分公司匹配：人介入，不兜底
      const office = await Office.getOfficeById(item.officeId)
      job.plannerOffice = office ? office.officeId : 0
      job.plannerDepartment = item.departmentId
    },
    async prePortPlannerChangeHandler(data) {
      await JobUtils.prePortPlannerChangeHandler(data, this.job, this)
    },
    async lastMilePlannerChangeHandler(data) {
      await JobUtils.lastMilePlannerChangeHandler(data, this.job, this)
    },
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    },
    /**
     * 操作改变
     */
    txtOPChangeHandler(user) {
      const job = this.job
      job.op = user.userId
      if (user.defaultDepId > 0) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    /**
     * 发货人选择
     */
    async shipperChange(data) {
      const job = this.job
      job.shipperId = data.value
      if (job.shipperId) {
        // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          job.shipperLine1 = manifestAddress.addressLine1
          job.shipperLine2 = manifestAddress.addressLine2
          job.shipperLine3 = manifestAddress.addressLine3
          job.shipperLine4 = manifestAddress.addressLine4
          job.shipperLine5 = manifestAddress.addressLine5
          job.shipperLine6 = manifestAddress.addressLine6
          job.shipperLine7 = manifestAddress.addressLine7
        } else {
          job.shipperLine1 = ''
          job.shipperLine2 = ''
          job.shipperLine3 = ''
          job.shipperLine4 = ''
          job.shipperLine5 = ''
          job.shipperLine6 = ''
          job.shipperLine7 = ''
        }
      }
    },
    /**
     * 收货人选择
     */
    async consigneeChange(data) {
      const job = this.job
      job.consigneeId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (job.consigneeId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          job.consigneeLine1 = manifestAddress.addressLine1
          job.consigneeLine2 = manifestAddress.addressLine2
          job.consigneeLine3 = manifestAddress.addressLine3
          job.consigneeLine4 = manifestAddress.addressLine4
          job.consigneeLine5 = manifestAddress.addressLine5
          job.consigneeLine6 = manifestAddress.addressLine6
          job.consigneeLine7 = manifestAddress.addressLine7
        } else {
          job.consigneeLine1 = ''
          job.consigneeLine2 = ''
          job.consigneeLine3 = ''
          job.consigneeLine4 = ''
          job.consigneeLine5 = ''
          job.consigneeLine6 = ''
          job.consigneeLine7 = ''
        }
      }
    },
    /**
     * 通知人选择
     */
    async notifyChange(data) {
      const job = this.job
      job.notifyId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (job.notifyId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          job.notifyLine1 = manifestAddress.addressLine1
          job.notifyLine2 = manifestAddress.addressLine2
          job.notifyLine3 = manifestAddress.addressLine3
          job.notifyLine4 = manifestAddress.addressLine4
          job.notifyLine5 = manifestAddress.addressLine5
          job.notifyLine6 = manifestAddress.addressLine6
          job.notifyLine7 = manifestAddress.addressLine7
        } else {
          job.notifyLine1 = ''
          job.notifyLine2 = ''
          job.notifyLine3 = ''
          job.notifyLine4 = ''
          job.notifyLine5 = ''
          job.notifyLine6 = ''
          job.notifyLine7 = ''
        }
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.job['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.job['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.job['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.job['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['notifyLine' + i] = ''
      }
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    loadingPortCode_Change(data) {
      this.job.loadingPortCode = data.value
      this.portChange()
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
    },
    /** 港口条款关联处理
     *  起运港----->分单签单地点----->主单签单地点
     *  分单运费条款 PP 分单付款地点-----起运港
     *              CC 分单付款地点-----目的港
     *
     *              3r 分单付款地点-----目的港
     *  主单运费条款 PP 主单付款地点-----起运港
     *              CC 主单付款地点-----目的港
     *              3r 主单付款地点-----无动作
     * 订舱，主单运费条款、分单运费条款，如果CC的情况，主单、分单付款地点应该自动刷目的港；
     */
    async portChange() {
      const job = new SeaExportJob(this.job)
      const hdoc = await job.getCargoDocByType('HBL', true)
      const mdoc = await job.getCargoDocByType('MBL', true)
      const loadingPort = this.context.seaPortList.find(p => p.code === job.loadingPortCode)
      const destinationPort = this.context.seaPortList.find(p => p.code === job.destinationPortCode)
      const dischargingPort = this.context.seaPortList.find(p => p.code === job.dischargingPortCode)
      // 提单起运港
      hdoc.loadingPort = loadingPort ? loadingPort.englishName : ''
      hdoc.loadingPortCode = job.loadingPortCode
      // 提单卸货港
      hdoc.dischargingPort = dischargingPort ? dischargingPort.englishName : ''
      hdoc.dischargingPortCode = job.dischargingPortCode
      // 提单交货地
      hdoc.destinationPort = destinationPort ? destinationPort.englishName : ''
      hdoc.destinationPortCode = job.destinationPortCode
      if (job.dischargingPortCode === job.destinationPortCode) {
        hdoc.destinationPort = dischargingPort ? dischargingPort.englishName : ''
      }
      // 交货地区域
      job.placeOfDeliveryRegion = destinationPort ? destinationPort.region : ''
      // 签发地点
      hdoc.signPlaceBL = this.getCity(loadingPort)
      mdoc.signPlaceBL = this.getCity(loadingPort)
      // 分单运费条款
      if (job.paymentTermHBL === 'PP') {
        // PP 分单付款地点-----起运港
        hdoc.paymentPlaceBL = !loadingPort ? '' : loadingPort.englishName
      } else if (job.paymentTermHBL === 'CC' || job.paymentTermHBL === '3P') {
        // CC 分单付款地点-----目的港 3r 分单付款地点-----目的港
        hdoc.paymentPlaceBL = !destinationPort ? '' : destinationPort.englishName
      }
      // 主单运费条款
      if (job.paymentTermMBL === 'PP' || job.paymentTermMBL === '3P' || job.paymentTermMBL === 'PPAC') {
        // PP 主单付款地点-----起运港
        mdoc.paymentPlaceBL = !loadingPort ? '' : loadingPort.englishName
      } else if (job.paymentTermMBL === 'CC') {
        // CC 主单付款地点-----目的港
        mdoc.paymentPlaceBL = !destinationPort ? '' : destinationPort.englishName
      } else if (job.paymentTermMBL === 'EW' || job.paymentTermMBL === 'EWAC' || job.paymentTermMBL === 'PPAE') {
        mdoc.paymentPlaceBL = ''
      }
      // 提单起运港
      mdoc.loadingPort = loadingPort ? loadingPort.englishName : ''
      mdoc.loadingPortCode = job.loadingPortCode
      // 提单卸货港
      mdoc.dischargingPort = dischargingPort ? dischargingPort.englishName : ''
      mdoc.dischargingPortCode = job.dischargingPortCode
      // 提单交货地
      mdoc.destinationPort = destinationPort ? destinationPort.englishName : ''
      mdoc.destinationPortCode = job.destinationPortCode
      if (job.dischargingPortCode === job.destinationPortCode) {
        mdoc.destinationPort = dischargingPort ? dischargingPort.englishName : ''
      }
    },
    getCity(port) {
      let city = this.context.office.cityName
      if (!city) {
        city = port ? port.englishName : ''
      }
      return city
    },
    async destinationPortCode_Change(data) {
      this.job.destinationPortCode = data.value
      // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
      if (parseInt(this.context.config.get('FinalDestinationChange')) === 1) {
        this.job.destinationPlace = data.englishName
        await this.changeDestinationPlace()
      }
      await this.portChange()
    },
    cargoSource_Change() {
      this.job.designationAgent = 0
      if (this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        if (this.isEdit) {
          this.job.destinationAgent = 0
        }
        this.customerIdChange()
      }
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
      this.loadCompanyUserByCargoSource()
      JobUtils.matchUserPortConfig(this, this.job)
    },
    // 新增函数，当指定货切换自揽货时调用
    customerIdChange() {
      if (this.isSpecifiedSalesBusiness) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
        this.loadSales(cmp)
      } else {
        if (this.job.customerId > 0) {
          this.getCustmerSales()
          this.loadSites()
        }
      }
    },
    async txtCargoSourceChangeHandler() {
      const job = this.job
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        job.paymentTermHBL = 'CC'
        job.designationAgent = 0
        if (!this.validateCustomerSales) {
          await this.getCustmerSales()
        }
      } else {
        job.paymentTermHBL = 'PP'
        if (!this.validateCustomerSales) {
          await this.loadOverseaAgentDetailOwner(job.designationAgent)
        }
      }
      this.portChange()
      if (!this.validateCustomerSales) {
        await this.loadCustomerPortDestinationAgents()
      }
    },
    /**
     * 自揽货： 选择客户，自动录入销售名字。
     * SC_CARGO_SOURCE 自揽货
     * NC_CARGO_SOURCE 指定货
     * 指定货： 选择代理，自动在销售处显示网管名字。
     */
    async getCustmerSales() {
      let cmp = null
      if (this.job.customerId > 0) {
        cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
      }
      if (cmp) {
        const customerDetail = await new Company(cmp).getCustomerDetail()
        await this.loadCustomerDetailHandler(customerDetail)
      } else {
        this.salesList = null
      }
    },
    async loadCustomerDetailHandler(customerDetail) {
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (customerDetail) {
        const data = { value: 0 }
        if (customerDetail.sales > 0) {
          const salseTemp = customerDetail.sales
          const user = this.context.userList.find(p => p.userId === salseTemp)
          if (user && user.active) {
            if (this.salesOfficeCheck) {
              for (const obj of officeSaleList) {
                if (user.userId === obj.userId) {
                  data.value = salseTemp
                }
              }
            } else {
              data.value = salseTemp
            }
          }
          if (data.value > 0) {
            const usr = this.context.userList.find(p => p.userId === data.value)
            Object.assign(data, usr)
          }
        }
        // 显示销售所属分公司
        await this.txtSales_changeHandler(data)
      }
    },
    /**
     * 指定货 -> 加载网管
     */
    async loadOverseaAgentDetailOwner(companyId) {
      let company = null
      if (companyId > 0) {
        company = this.context.companyList.find(p => p.cmpIdx === companyId)
      }
      if (company) {
        const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
        await this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
      }
    },
    loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
      const data = { value: 0 }
      if (overseaAgentDetail) {
        // 添加指定货代理等级
        const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
        if (overseaAgentGrade) {
          this.job.agentLevel = overseaAgentGrade.chineseName
        }
        const user = this.context.userList.find(p => p.userId === overseaAgentDetail.owner)
        if (user) {
          if (this.salesOfficeCheck) {
            if (user.active) {
              Object.assign(data, user)
              data.value = overseaAgentDetail.owner
            }
          } else {
            Object.assign(data, user)
            data.value = overseaAgentDetail.owner
          }
        }
      }
      return this.txtSales_changeHandler(data)
    },
    async loadCustomerPortDestinationAgents() {
      if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && this.job.customerId > 0) {
        const company = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
        if (company) {
          await new Company(company).getCustomerDetail()
          await this.loadCustomerDetail1Handler(company.customerDetail)
        }
      }
    },
    async loadCustomerDetail1Handler(customerDetail) {
      if (customerDetail) {
        const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
        await this.loadPortDestinationAgentsHandler(portDestinationAgents)
      }
    },
    async loadPortDestinationAgentsHandler(portDestinationAgents) {
      if (portDestinationAgents) {
        for (const agent of portDestinationAgents) {
          if (this.job.dischargingPortCode === agent.destinationPort) {
            this.job.designationAgent = agent.destinationAgentId
            await this.loadOverseaAgentDetailOwner(this.job.designationAgent)
          }
        }
      }
    },
    async txtDestinationAgentChangeHandler(data) {
      if (data.cmpIdx) {
        // 自动目的港代理
        if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && (Number(this.context.config.get('refSelDesignationAgent')) === 1 || this.job.designationAgent === 0)) {
          const designationAgentCompany = await Company.getCompanyById(data.cmpIdx)
          if (designationAgentCompany && designationAgentCompany.designationAgent) {
            this.job.designationAgent = data.cmpIdx
          }
        }
        this.job.destinationAgent = data.cmpIdx
        await CargoDocUtil.checkOverseaAgentProperties(this.job, true)
      } else {
        this.job.destinationAgent = 0
      }
      OverseaCustomerUtils.destinationAgentChangeHandler(this)
    },
    txtDesignationAgentChangeHandler(data) {
      this.job.designationAgent = data.value
      if (this.job.designationAgent > 0) {
        this.loadOverseaAgentDetail()
      }
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
    },
    /**
     * 加载指定货代理
     */
    loadOverseaAgentDetail() {
      const job = this.job
      if (job.designationAgent > 0) {
        const company = this.context.companyList.find(p => p.cmpIdx === job.designationAgent)
        if (company) {
          this.loadOverSeaResultHandler()
        }
      }
    },
    /**
     * 指定货代理 销售处显示网管名字。
     */
    loadOverSeaResultHandler() {
      if (this.job.designationAgent > 0) {
        this.loadOverseaAgentDetailOwner(this.job.designationAgent)
      }
    },
    bookingAgentChangeHandler(data) {
      if (!data.value) {
        this.job.bookingAgent = 0
        return
      }
      if (this.job.bookingAgent && parseInt(this.job.bookingAgent) > 0) {
        this.job.preBookingAgent = this.job.bookingAgent
      }
      this.context.reloadCharge = SEUtils.refreshChargeAccountId(this.job, 'bookingAgent', this.view.$t('SeaExport.BookingAgent'), this.context.modifiedData)
      this.job.bookingAgent = data.value
      if (this.job.bookingAgent > 0 && this.job.carrierId === 0) {
        if (data.seaCmp) {
          this.job.carrierId = data.cmpIdx
        }
      }
    },

    /**
     * 报关行
     */
    customsBrokerChangeHandler(data) {
      const job = this.job
      // 这个验证必须在 job.customsBroker = data.value 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(job, 'customsBroker', this.view.$t('SeaExport.CustomsBroker'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      job.customsBroker = data.value
      this.view.context.reloadCharge = true
    },

    /**
     * vessel change
     */
    onVesselSelectionChange(data) {
      this.job.vessel = data.value
      this.getVoyageByVessel(data)
      if (data.value && data.uuid) {
        this.job.vesselIMO = data.imoCode
      } else {
        this.job.vesselIMO = ''
      }
    },
    async getVoyageByVessel(data) {
      if (data.vesselId) {
        this.voyages = await Voyage.getVoyage(data.vesselId)
      } else {
        this.voyages = []
      }
    },
    txtVoyageFocusInHandler() {
      const judgmentOfVoyageNo = this.context.config.get('JudgmentOfVoyageNo')
      if (judgmentOfVoyageNo !== '1') {
        return
      }
      let value = 'V.'
      if (this.job.voyageFlight) {
        value = this.job.voyageFlight
        this.job.voyageFlight = ''
      }
      this.$nextTick(() => {
        this.job.voyageFlight = value
        const elSelect = this.$refs.voyageFlight.$refs.cargoAdvanceSelect
        const innerInput = elSelect.$children[0].$refs.input
        innerInput.value = this.job.voyageFlight
      })
    },
    async containerLoadType_Change(ignorDefault = false) {
      const job = this.job
      if (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        if (!ignorDefault || !job.bookingTerm) {
          job.bookingTerm = BookingTerm.NS_BOOKING_TYPE.code
        }
      }
      this.seaEqDateCl()
      if (job.containerLoadType === 'LCL' || job.containerLoadType === 'BB') {
        if (!ignorDefault || typeof job.ams !== 'boolean') {
          job.ams = true
        }
      }
      if (job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code ||
          job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) {
        if (!ignorDefault) {
          this.$refs.bookingSeaEqDataGrid.clear()
        }
      }
      this.changeDefaultHBLPayment(ignorDefault)
      // 判断客户是否有维护默认的主单和分单运输条款
      const shippingTermList = await getSpecificBasicData(basicCacheKeys.basic_data_ShippingTerm)
      if (shippingTermList && shippingTermList.length > 0) {
        for (const shippingTerm of shippingTermList) {
          let isFind = false
          const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
          if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
            for (const item of shippingTermOperationTypes) {
              if (item.containerLoadType === job.containerLoadType && item.mbl && item.lob === SystemConstants.SE.code) {
                isFind = true
                break
              }
            }
          }
          if (isFind) {
            job.freightTerm = shippingTerm.code
            break
          }
        }
        for (const shippingTerm of shippingTermList) {
          let isFind = false
          const shippingTermOperationTypes = shippingTerm.shippingTermOperationTypes
          if (shippingTermOperationTypes && shippingTermOperationTypes.length > 0) {
            for (const item of shippingTermOperationTypes) {
              if (item.containerLoadType === job.containerLoadType && !item.mbl && item.lob === SystemConstants.SE.code) {
                isFind = true
                break
              }
            }
          }
          if (isFind) {
            job.freightTermHBL = shippingTerm.code
            break
          }
        }
      }
      if (!ignorDefault) {
        JobUtils.matchUserPortConfig(this, this.job, true)
        JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
      }
    },
    /**
     * 箱型信息控制
     */
    async seaEqDateCl() {
      const job = this.job
      let eq = null
      await new SeaExportJob(this.job).getSeaEQ()
      if (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        if (job.seaEQ.length === 0) {
          eq = new SeaEQ().fillDefaultValue().getData()
          eq.EQtype = 'GP'
          eq.EQsize = '20'
          eq.EQquantity = 1
          eq.jobUuid = job.uuid
          job.seaEQ.push(eq)
          ContainerUtil.autoJustContainerUsages(job)
        }
      } else if (job.containerLoadType !== ContainerLoadType.FCL_CARGO_TYPE.code && job.seaEQ && job.seaEQ.length > 0) {
        job.seaEQ = []
      }
    },
    changeDefaultHBLPayment(ignorDefault) {
      const job = this.job
      if (ignorDefault && job.freightTermHBL) {
        return
      }
      if (job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code) {
        job.freightTermHBL = 'CY-CY'
      } else if (job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        job.freightTermHBL = 'CFS-CFS'
      }
    },
    /**
     * 运输公司
     */
    carryingCmpChangeHandler(data) {
      const job = this.job
      // 这个验证必须在 job.carryingCmp = data.value 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(job, 'carryingCmp', this.view.$t('SeaExport.HaulageCompany'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      job.carryingCmp = data.value
      this.view.context.reloadCharge = true
      if (job.trucking.length === 0) {
        const newData = new TruckingInfo().fillDefaultValue().getData()
        newData.loadingPortService = true
        newData.jobUuid = job.uuid
        job.trucking.push(newData)
      }
      const truckingInfo = job.trucking[0]
      truckingInfo.carryingCmp = job.carryingCmp
      if (!job.carryingCmp || job.carryingCmp === 0) {
        truckingInfo.driver = ''
        truckingInfo.driverTel = ''
      }
      this.addTruckingToModifiedSet(truckingInfo)
    },
    doorsChangeHandler() {
      const door = this.doorList.find(p => p.name === this.truckingInfo.doorName)
      if (door) {
        this.truckingInfo.doorMan = door.contact
        this.truckingInfo.doorManTel = door.phone
        this.truckingInfo.doorAddr = door.address
      }
    },
    endTabHandler() {
      this.fillModel()
    },
    async fillModel() {
      const model = this.job
      // 如果是自有约价，且是录入的船名，则清空该船名，选择的船名不清除
      if ((this.editVesselVoyageMode === 3 && !model.vessel) || (this.editVesselVoyageMode === 2 && model.bookingTerm === BookingTerm.OS_BOOKING_TYPE.code && !model.vessel)) {
        model.vessel = ''
      }
      model.booking = true
      model.signHBL = model.mblOnly ? false : model.signHBL
      if (!model.transfering) {
        model.transferPortCode = ''
      }
      if (model.shipperId > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === model.shipperId)
        model.shipperCode = cmp ? cmp.shortName : ''
      }
      if (model.consigneeId > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === model.consigneeId)
        model.consigneeCode = cmp ? cmp.shortName : ''
      }
      if (model.notifyId > 0) {
        const cmp = this.context.companyList.find(p => p.cmpIdx === model.notifyId)
        model.consigneeCode = cmp ? cmp.shortName : ''
      }
      const packing = this.context.packingList.find(p => p.code === model.packing)
      this.hdoc.quantitySum = StrUtils.jsdx(model.quantityActual, packing ? packing.name : model.packing)
      if (!this.hdoc.uuid) {
        CargoDocUtil.changeJobSynToBillOfLading(model, this.hdoc)
      }
      if (model.warehousing) {
        model.loadingTerm = StuffyType.IS_STUFFY_TYPE.code
      } else if (model.landTransportation) {
        model.loadingTerm = StuffyType.DD_STUFFY_TYPE.code
      } else {
        model.loadingTerm = StuffyType.SD_STUFFY_TYPE.code
      }
      if (model.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
        model.designationAgent = 0
      }
      // 默认创建门点
      if (model.landTransportation) {
        const door = this.doorList.find(p => p.name === this.truckingInfo.doorName)
        if (!door) {
          this.newDoor()
        }
      }
      // 同步job的收发通到MBL中  modify by Marco: 2016-04-18
      if (this.mblDoc || model.signMBL) {
        await CargoDocUtil.initMBLProperties(this.mblDoc, this.job, '', true)
        CargoDocUtil.checkOverseaAgentProperties(model, true)
        if (model.mblOnly) {
          CargoDocUtil.copyBasicConsignee(this.mblDoc, model)
        }
        CargoDocUtil.copyBasicNotify2(this.mblDoc, model)
      }
      if (this.hdoc || model.signHBL) {
        await CargoDocUtil.initHBLProperties(this.hdoc)
      }
      new SeaExportJob(model).copySCNotifyToDoc(this.hdoc)
      if (Number(this.context.config.get('seaInsidePacking')) === 1) {
        this.mblDoc.insidePacking = model.insidePacking
        this.hdoc.insidePacking = model.insidePacking
      }
      // 同步装箱信息
      ContainerUtil.autoJustContainerUsages(model)
    },
    newDoor() {
      if (!this.job.customerId) {
        return
      }
      if (!this.truckingInfo.doorName) {
        return
      }
      // 填写内容是下拉框中的数据源
      const inputDoor = this.doorList.find(p => p.name === this.truckingInfo.doorName)
      if (inputDoor) {
        return
      }
      const cmp = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
      const door = {
        name: this.truckingInfo.doorName,
        contact: this.truckingInfo.doorMan,
        phone: this.truckingInfo.doorManTel,
        address: this.truckingInfo.doorAddr,
        companyUuid: cmp.uuid
      }
      addSites(door)
    },
    async getSubmitData() {
      await this.validateForm()
      const job = this.job
      let containerUsages = []
      if (job.lclMasterUuid && (!job.containers || job.containers.length <= 0) && job.containerUsages && job.containerUsages.length > 0) {
        containerUsages = job.containerUsages
      }
      return {
        job,
        seaCargoDoc: job.seaCargoDoc,
        seaEQ: job.seaEQ,
        delseaEQUuids: job.delseaEQUuids,
        containers: job.containers,
        containerUsages,
        delContainerUuids: job.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: job.delContainerUsageUuids // 删除的装箱uuid
      }
    },
    async validateForm() {
      // CARGO-666 河北环海：业务编号规则出错 qm 19/12/2
      if (this.job.opOffice < 1) {
        throw new TabError(this.$t('CargoMsg.Cargo_OperatingCompanyCannotBeEmpty'), 'tabSeBooking')
      }
      if (this.job.customerId < 1) {
        throw new TabError(this.$t('CargoMsg.Cargo_ConsignationCompanyCannotBeNull'), 'tabSeBooking')
      }
      await JobUtils.checkCustomerBranchScope(this.job, 'tabSeBooking')
      await SecurityUtil.companyisActive(this.$t('SeaExport.Customer'), this.job.customerId, 'tabSeBooking')
      if (!this.job.etd) {
        throw new TabError(this.$t('CargoMsg.Cargo_DateOfDepartureCannotBeNull'), 'tabSeBooking')
      }
      if (this.showBargeCustomCutoff && !this.job.bargeCustomCutoff) {
        throw new TabError(this.$t('CargoMsg.Cargo_ThereAreBargesTips'), 'tabSeBooking')
      }
      if (!this.job.loadingPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_POLCannotBeNull'), 'tabSeBooking')
      }
      if (this.job.transfering && !this.job.transferPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_TransitCannotBeNull'), 'tabSeBooking')
      }
      if (!this.job.dischargingPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_PortOfDischargeCannotBeNull'), 'tabSeBooking')
      }
      if (!this.job.destinationPortCode) {
        throw new TabError(this.$t('CargoMsg.Cargo_DeliveryCannotBeNull'), 'tabSeBooking')
      }
      if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && this.job.designationAgent === 0) {
        throw new TabError(this.$t('CargoMsg.Cargo_DesignatedCannotBeNull'), 'tabSeBooking')
      }
      // 截关日期不能大于开航日期
      if (this.job.customCutoff && this.job.etd < this.job.customCutoff) {
        throw new TabError(this.$t('CargoMsg.Cargo_ClosingDateCannotBeGreaterThanTheSailingDate'), 'tabSeBooking')
      }
      // 驳船截关日期不能大于截关日期
      if (this.job.bargeCustomCutoff && this.job.customCutoff && this.job.customCutoff < this.job.bargeCustomCutoff) {
        throw new TabError(this.$t('CargoMsg.Cargo_ClosingDateOfBargeTips'), 'tabSeBooking')
      }
      if (this.job.sales <= 0) {
        throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabSeBooking')
      }
      if (this.job.salesOffice <= 0) {
        throw new TabError(this.$t('Message.SalesBranchCompanyIsNullPleaseReSelectSales'), 'tabSeBooking')
      }
      if (this.job.salesDepartment <= 0) {
        throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabSeBooking')
      }
      if (this.context.config.get('SERequirePONO') === '1' && !this.job.poNo) {
        throw new TabError(this.$t('CargoMsg.Cargo_ItemNumberCannotBeEmpty'), 'tabSeBooking')
      }
      if (this.job.containerLoadType === 'FCL') {
        if (this.job.seaEQ.length === 0) {
          throw new TabError(this.$t('CargoMsg.Cargo_ContainerTypeCanTBeEmpty'), 'tabSeBooking')
        }
      }
      if ((this.job.containerLoadType === 'FCL' || this.job.containerLoadType === 'BB') && this.job.seaEQ.length > 0) {
        if (ContainerUtil.checkNoDuplationSeaEQ(this.job)) {
          throw new TabError(this.$t('SeaExport.RepeatBoxType'), 'tabSeBooking')
        }
      }
      for (let i = 1; i <= 4; ++i) {
        if (this.job['userDefinedField' + i].length > 512) {
          throw new TabError(this.$t('CargoMsg.Cargo_CustomizedField') + i + this.$t('Sales.CharacterTooLongPleaseAgain'), 'tabSeBooking')
        }
      }
      const msg = ContainerUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabSeBooking')
      }
      return true
    },
    executeTask() {
      // 保存客户发运信息
      this.addrPM.job = this.job
      this.addrPM.isPortFilter = true
      this.addrPM.shipperCodeField = ''
      this.addrPM.shipperField = 'shipperLine'
      this.addrPM.consigneeCodeField = ''
      this.addrPM.consigneeField = 'consigneeLine'
      this.addrPM.notifyCodeField = ''
      this.addrPM.notifyField = 'notifyLine'
      this.addrPM.viewFromBasic = true
      if (parseInt(this.context.config.get('syncMailingAddress')) === 1) {
        this.addrPM.saveCheck()
      }
    },
    // 提单卸货港
    async changeDischargingPort() {
      const job = this.job
      const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      const hbl = await new SeaExportJob(job).getMainHbl()
      this.refreshPortCode()
      let portEnglishName = ''
      if (job.dischargingPortCode && job.dischargingPortCode.length > 0) {
        const port = seaPorts.find(p => p.code === job.dischargingPortCode)
        if (port) {
          portEnglishName = port.englishName
          job.placeOfDeliveryRegion = port.region
        }
      }
      if (hbl) {
        if (hbl.state > 1) return
        if (job.dischargingPortCode) {
          hbl.destinationPortCode = job.dischargingPortCode
          hbl.dischargingPortCode = job.dischargingPortCode
          hbl.dischargingPort = portEnglishName
          if (job.dischargingPortCode === job.destinationPortCode) {
            hbl.destinationPort = portEnglishName
          }
        }
      }
      const mdoc = await new SeaExportJob(job).getMainMbl()
      if (mdoc) {
        if (mdoc.state > 1) return
        if (job.dischargingPortCode) {
          mdoc.dischargingPortCode = job.dischargingPortCode
          mdoc.dischargingPort = portEnglishName
          mdoc.dischargingPortCode = job.dischargingPortCode
          if (job.dischargingPortCode === job.destinationPortCode) {
            mdoc.destinationPort = portEnglishName
          }
        }
      }
      this.portChange()
      JobUtils.matchUserPortConfig(this, job, true)
      JobUtils.matchRegionWarehouseMappingConfig(job, null, true)
    },
    // 提单最终目的地
    async changeDestinationPlace() {
      const job = this.job
      const hbl = await new SeaExportJob(job).getMainHbl()
      if (hbl) {
        if (hbl.state > 1) return
        hbl.destinationPlace = job.destinationPlace
      }
      const mbl = await new SeaExportJob(job).getMainMbl()
      if (mbl) {
        if (mbl.state > 1) return
        mbl.destinationPlace = job.destinationPlace
      }
    },
    // 自定义岗位字段1
    async userDefinedRoleId1Handler(data) {
      const job = this.job
      job.userDefinedRoleId1 = data.value || 0
      job.userDefinedRoleDept1 = 0
      job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept1 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice1 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
          job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice1 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段2
    async userDefinedRoleId2Handler(data) {
      const job = this.job
      job.userDefinedRoleId2 = data.value || 0
      job.userDefinedRoleDept2 = 0
      job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept2 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice2 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
          job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice2 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段3
    async userDefinedRoleId3Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId3 = value || 0
      job.userDefinedRoleDept3 = 0
      job.userDefinedRoleOffice3 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept3 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice3 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
          job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice3 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段4
    async userDefinedRoleId4Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId4 = value || 0
      job.userDefinedRoleDept4 = 0
      job.userDefinedRoleOffice4 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept4 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice4 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
          job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice4 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段5
    async userDefinedRoleId5Handler(data) {
      const job = this.job
      job.userDefinedRoleId5 = data.value || 0
      job.userDefinedRoleDept5 = 0
      job.userDefinedRoleOffice5 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept5 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice5 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
          job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice5 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段6
    async userDefinedRoleId6Handler(data) {
      const job = this.job
      job.userDefinedRoleId6 = data.value || 0
      job.userDefinedRoleDept6 = 0
      job.userDefinedRoleOffice6 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept6 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice6 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
          job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice6 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段7
    async userDefinedRoleId7Handler(data) {
      const job = this.job
      job.userDefinedRoleId7 = data.value || 0
      job.userDefinedRoleDept7 = 0
      job.userDefinedRoleOffice7 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept7 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice7 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
          job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice7 = office ? office.officeId : 0
        }
      }
    },
    /**
     * 修改船公司
     */
    async carrierChangeHandler(data) {
      this.job.carrierId = data.value || 0
      this.refreshPortCode()
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
    },
    /**
     * 订舱输入卸货港后,船名航次页签卸货港代码会根据参数自动选择港口五子码,五子码希望和EDI的港口一样
     */
    refreshPortCode() {
      const job = this.job
      if (!this.sEUseDischargingPort5Code || (!job.dischargingPortCode && !job.carrierId)) return
      if (job.dischargingPortCode && job.carrierId) {
        const params = {
          sourceCode: job.dischargingPortCode,
          carrierId: job.carrierId,
          officeId: this.view.$store.getters.currentOfficeId
        }
        getPortCodeByMapping(params).then(res => {
          job.portCode = res.data
        }).catch().finally()
      } else {
        if (job.dischargingPortCode) {
          if (this.context.seaPortList && this.context.seaPortList.length > 0) {
            for (const seaPort of this.context.seaPortList) {
              if (job.dischargingPortCode === seaPort.code) {
                job.portCode = seaPort.code
                break
              }
            }
          }
        }
      }
    },
    // 委托件数修改
    async quantityContractChange() {
      await SEUtils.changeQWCRule(async() => {
        this.job.quantityActual = this.job.quantityContract
        await this.changeSynBillOfLadingQWC()
      }, null)
    },
    // 委托重量修改
    async weightContractChange() {
      await SEUtils.changeQWCRule(async() => {
        this.job.weightActual = this.job.weightContract
        await this.changeSynBillOfLadingQWC()
      }, null)
    },
    // 委托体积修改
    async cubageContractChange() {
      await SEUtils.changeQWCRule(async() => {
        this.job.cubageActual = this.job.cubageContract
        await this.changeSynBillOfLadingQWC()
      }, null)
    },
    // 实际件数修改
    async quantityActualChange() {
      await SEUtils.changeQWCRule(null, () => {
        this.job.quantityContract = this.job.quantityActual
      })
      await this.changeSynBillOfLadingQWC()
    },
    // 实际重量修改
    async weightActualChange() {
      await SEUtils.changeQWCRule(null, () => {
        this.job.weightContract = this.job.weightActual
      })
      await this.changeSynBillOfLadingQWC()
    },
    // 实际体积修改
    async cubageActualChange() {
      await SEUtils.changeQWCRule(null, () => {
        this.job.cubageContract = this.job.cubageActual
      })
      await this.changeSynBillOfLadingQWC()
    },
    async changeSynBillOfLadingQWC() {
      await CargoDocUtil.changeSynBillOfLadingQWC(this.job, this.job.quantityActual, this.job.weightActual, this.job.cubageActual)
    },
    async cargoSalesChargeHandler(data) {
      const job = this.job
      job.cargoSalesId = data.value || 0
      job.cargoSalesDepartment = 0
      job.cargoSalesOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.cargoSalesOffice = office ? office.officeId : 0
              job.cargoSalesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'salesOfGoods')
          if (department) {
            job.cargoSalesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            job.cargoSalesOffice = office ? office.officeId : 0
          }
        }
      }
    },
    async changeProject(p) {
      this.job.poNo = p.value
      this.job.projectName = p.projectName
      if (this.isProjectLinkedCustomer) {
        const company = await getPartnerByPoNo(this.job.poNo).then(res => {
          return res.data
        })
        if (company && this.job.customerId !== company.cmpIdx && company.active) {
          await this.txtCustomerId_changeHandler(company)
        }
      }
    },
    clearPoNo() {
      if (this.isProjectLinkedCustomer) {
        this.job.poNo = ''
        this.job.projectName = ''
      }
    },
    loadCompanyUserByCargoSource() {
      if (this.isSpecifiedSalesBusiness && this.job.cargoSource) {
        const company = this.context.companyList.find(p => p.cmpIdx === this.job.customerId)
        if (company) {
          Company.getCompanyUsers(company.uuid).then(data => {
            const companyUsers = data.filter(p => (p.cargoSource === this.job.cargoSource || !p.cargoSource))
            this.loadCompanyUserByCargoSourceHandler(companyUsers)
          })
        }
      }
    },
    loadCompanyUserByCargoSourceHandler(companyUsers) {
      const job = this.job
      // 客服
      const csrList = []
      // 对应揽货类型的客服
      const csrCargoSourceList = []
      let csrDefaultId = 0
      // 单证
      const dcList = []
      // 对应揽货类型的单证
      const dcCargoSourceList = []
      let dcDefaultId = 0
      // 自定义岗位1
      const userDefinedRoleId1List = []
      // 对应揽货类型的自定义岗位1
      const userDefinedRoleId1CargoSourceList = []
      let userDefinedRoleId1 = 0
      // 自定义岗位2
      const userDefinedRoleId2List = []
      // 对应揽货类型的自定义岗位2
      const userDefinedRoleId2CargoSourceList = []
      let userDefinedRoleId2 = 0
      // 如果开启分公司过滤参数，查出来所有分公司
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          if (u.lob === 'SE' || u.lob === 'ALL') {
            const user = this.context.userList.find(p => p.userId === u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
                if (u.defaultUser) {
                  csrDefaultId = u.userId
                }
                if (u.cargoSource === job.cargoSource) {
                  csrCargoSourceList.push(user)
                } else {
                  csrList.push(user)
                }
              } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
                if (u.defaultUser) {
                  dcDefaultId = u.userId
                }
                if (u.cargoSource === job.cargoSource) {
                  dcCargoSourceList.push(user)
                } else {
                  dcList.push(user)
                }
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE1.code) { // 自定义岗位1
                if (u.defaultUser) {
                  userDefinedRoleId1 = u.userId
                }
                if (u.cargoSource === job.cargoSource) {
                  userDefinedRoleId1CargoSourceList.push(user)
                } else {
                  userDefinedRoleId1List.push(user)
                }
              } else if (u.roleType === CargoOfRoleType.USER_DEFINED_ROLE2.code) { // 自定义岗位2
                if (u.defaultUser) {
                  userDefinedRoleId2 = u.userId
                }
                if (u.cargoSource === job.cargoSource) {
                  userDefinedRoleId2CargoSourceList.push(user)
                } else {
                  userDefinedRoleId2List.push(user)
                }
              }
            }
          }
        }
      }
      // 客服
      if (csrCargoSourceList.length > 0) {
        job.csr = csrCargoSourceList[0].userId
        this.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.csr)
          this.csrChangeHandler({ ...user, value: user.userId })
        })
      } else if (csrList.length > 0) {
        if (csrDefaultId > 0) {
          job.csr = csrDefaultId
        } else {
          job.csr = csrList[0].userId
        }
        this.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.csr)
          this.csrChangeHandler({ ...user, value: user.userId })
        })
      } else {
        job.csrs = 0
        job.csrsDepartment = 0
        job.csrsOffice = 0
      }
      // 单证
      if (dcCargoSourceList.length > 0) {
        job.dc = dcCargoSourceList[0].userId
        this.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.dc)
          this.dcChangeHandler({ ...user, value: user.userId })
        })
      } else if (dcList.length > 0) {
        if (dcDefaultId > 0) {
          job.dc = dcDefaultId
        } else {
          job.dc = dcList[0].userId
        }
        this.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.dc)
          this.dcChangeHandler({ ...user, value: user.userId })
        })
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
      // 自定义岗位1
      if (userDefinedRoleId1CargoSourceList.length > 0) {
        job.userDefinedRoleId1 = userDefinedRoleId1CargoSourceList[0].userId
      } else if (userDefinedRoleId1List.length > 0) {
        job.userDefinedRoleId1 = userDefinedRoleId1 > 0 ? userDefinedRoleId1 : userDefinedRoleId1List[0].userId
        this.view.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.userDefinedRoleId1)
          this.userDefinedRoleId1Handler({ ...user, value: user.userId })
        })
      } else {
        job.userDefinedRoleId1 = 0
        job.userDefinedRoleId1Department = 0
        job.userDefinedRoleId1Office = 0
      }
      // 自定义岗位2
      if (userDefinedRoleId2CargoSourceList.length > 0) {
        job.userDefinedRoleId2 = userDefinedRoleId2CargoSourceList[0].userId
      } else if (userDefinedRoleId2List.length > 0) {
        job.userDefinedRoleId2 = userDefinedRoleId2 > 0 ? userDefinedRoleId2 : userDefinedRoleId2List[0].userId
        this.view.$nextTick(() => {
          const user = this.context.userList.find(p => p.userId === job.userDefinedRoleId2)
          this.userDefinedRoleId2Handler({ ...user, value: user.userId })
        })
      } else {
        job.userDefinedRoleId2 = 0
        job.userDefinedRoleId2Department = 0
        job.userDefinedRoleId2Office = 0
      }
    },
    socChange() {
      if (this.job.soc) {
        this.job.socType = 1 // 默认为货主SOC
      } else {
        this.job.socType = 0 // 去掉否选的时候，清空
      }
    },
    // 加载指定销售
    loadSales(company) {
      if (this.isSpecifiedSalesBusiness) {
        if (company) {
          Company.getCompanyUsers(company.uuid).then(data => {
            this.loadSalesHandler(data)
          })
        }
      }
    },
    // 加载销售
    async loadSalesHandler(companyUsers) {
      const job = this.job
      // 销售
      let salesList = []
      let salesDefaultId = 0
      // 揽货销售
      const cargoSalesList = []
      let cargoSalesId = 0
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        for (const u of companyUsers) {
          if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
            const user = this.context.userList.find(p => p.userId === u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      if (u.defaultUser) {
                        salesDefaultId = u.userId
                      }
                      if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                        salesList = [user, ...salesList]
                      } else {
                        salesList.push(user)
                      }
                    }
                  }
                } else {
                  if (u.defaultUser) {
                    salesDefaultId = u.userId
                  }
                  if (this.validateCustomerSales && u.userId === this.context.user.userId) {
                    salesList = [user, ...salesList]
                  } else {
                    salesList.push(user)
                  }
                }
              } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
                if (u.defaultUser) {
                  cargoSalesId = u.userId
                }
                cargoSalesList.push(user)
              }
            }
          }
        }
      }
      if (this.isSpecifiedSalesBusiness) {
        this.salesList = salesList
        if (salesList.length > 0) {
          if (salesDefaultId > 0) {
            if (!this.validateCustomerSales) {
              job.sales = salesDefaultId
            } else {
              job.sales = salesList[0].userId
            }
          } else {
            job.sales = salesList[0].userId
          }
          this.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.sales)
            this.txtSales_changeHandler({ ...user, value: user.userId })
          })
        } else {
          job.sales = 0
          job.salesDepartment = 0
          this.txtSalesOffice = ''
        }
        // 揽货销售
        if (cargoSalesList.length > 0) {
          if (cargoSalesId > 0) {
            job.cargoSalesId = cargoSalesId
          } else {
            job.cargoSalesId = cargoSalesList[0].userId
          }
          this.$nextTick(() => {
            const user = this.context.userList.find(p => p.userId === job.cargoSalesId)
            this.cargoSalesChargeHandler({ ...user, value: user.userId })
          })
        } else {
          job.cargoSalesId = 0
          job.cargoSalesOffice = 0
          job.cargoSalesDepartment = 0
        }
      }
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.job, isRemoteBooking: true })
    },
    etdChange() {
      if (this.job.etd) {
        JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
      }
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.job, true)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, null, true)
      // 自定义业务类型为J类/K类时，自动勾选"目的港服务"（可手动取消）
      if (this.isCustomJobTypeJK(this.job)) {
        this.job.destinationPortService = true
      }
    },
    // 判断自定义业务类型是否为J类/K类
    isCustomJobTypeJK(job) {
      const code = job && job.customJobType
      if (!code) return false
      if (code === 'J' || code === 'K') return true
      const item = resolveSpecificField2ItemByCustomType(cacheKeys.basic_data_CutomJobType, 'code', code, job.lob)
      const name = (item && (item.localName || item.name || item.englishName)) || ''
      return name.startsWith('J类') || name.startsWith('K类')
    },
    onCargoTypeChange() {
      JobUtils.matchUserPortConfig(this, this.job, true)
    },
    async checkNewJobCreditInfo() {
      const job = this.job
      if (this.creditOpen && StrUtils.isEmpty(job.uuid)) {
        const params = JobUtils.getCreditCheckJob(job)
        await canCreateByCreditInfoDetail(params).then(async res => {
          if (res.data > 0) {
            const msg = {
              dangerouslyUseHTMLString: true,
              message: await JobUtils.checkDateAndAmountExceeded(res.data),
              type: 'warning',
              duration: 5000
            }
            this.$message.warning(msg)
            if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
              job.designationAgent = 0
            } else {
              job.customerId = 0
            }
          }
        })
      }
    },
    async dischargingPortCodeChange(data) {
      this.job.dischargingPortCode = data.value || ''
      const oldDestinationPortCode = this.job.destinationPortCode
      if (parseInt(this.context.config.get('SyncPOD')) === 1) {
        this.job.destinationPortCode = this.job.dischargingPortCode
      } else {
        this.job.destinationPortCode = this.job.destinationPortCode || this.job.dischargingPortCode
      }
      let port = null
      if (this.job.destinationPortCode) {
        const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
        port = seaPorts.find(p => p.code === this.job.destinationPortCode)
      }
      this.job.placeOfDeliveryRegion = port ? port.region : ''
      if (port && oldDestinationPortCode !== this.job.destinationPortCode && parseInt(this.context.config.get('FinalDestinationChange')) === 1) {
        this.job.destinationPlace = port.englishName
        await this.changeDestinationPlace()
      }
      await this.changeDischargingPort()
    }
  }
}
